// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3Csbj","tab":"Tabs_tab__3GJqX","tabActive":"Tabs_tabActive__3Vw0A"};